<template>
  <div></div>
</template>

<script>
  import { loginConsumeSystem } from '@/config/api';

  export default {
    name: 'Consumption',
    data() {
      return {};
    },
    created() {
      loginConsumeSystem().then((res) => {
        if (res.data.resCode == 200) {
          window.open(res.data.data);
        }
      });
    },
  };
</script>

<style scoped></style>
